/* Name: Upload.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/

import { Box, Typography, List } from '@mui/material';
import React from "react";
import { useState } from 'react';
import ErrorBoundary from './components/error-boundary';
import FileSelection from './components/handleFileSelection';
import ListSWItems from './components/ListSW';
import {FilterButton} from './components/ListSW';


const FILTER_MAP = {
  All: () => true,
  WithMeta: (item) => item.metadata,
  Completed: () => false,
};

const FILTER_NAMES = Object.keys(FILTER_MAP);
const UPLOAD_ROLES = new Set(['admin', 'announcement_editor', 'infomonitor_vendor']);

export const Upload = ({ userInfo }) => {
    const [filter, setFilter] = useState("All");

    //Render filter buttons and memorize the setting
    const filterList = FILTER_NAMES.map((name) => (
      <FilterButton
        key={name}
        name={name}
        isPressed={name === filter}
        setFilter={setFilter}
      />
    ));

    /*let isAuthenticated = (SM4BypassAuth() || useIsAuthenticated());*/
    return (
      <>
      <div className="App">
          <ErrorBoundary>
            <Box m={4}>
              {/* App Title */}
              <Typography variant="h4" gutterBottom>
                Upload Software Files
              </Typography>

              {/* File Selection Section */}
              { userInfo.userRoles.some((role) => UPLOAD_ROLES.has(role)) ?
                <Box display="block" justifyContent="left" alignItems="left" flexDirection="column" my={4} >
                  <FileSelection/>
                </Box>
                :
                <></>
              }
            </Box>
            <Box>
              {/*filterList*/}
              <List component="nav" aria-labelledby="nested-list-subheader">
                  <ListSWItems show={filter} choices={FILTER_MAP}/>
              </List>
            </Box>
          </ErrorBoundary>
      </div>
      </>
    );
  };
